import { render, staticRenderFns } from "./AccountsActions.vue?vue&type=template&id=63b822b7&"
import script from "./AccountsActions.vue?vue&type=script&lang=js&"
export * from "./AccountsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports